import { INITIALIZE_FORM } from '../actionTypes';
import { managePasswordActions } from '../reducer';

export default (values) => managePasswordActions[INITIALIZE_FORM](values);
